module.exports = __webpack_public_path__ + "static/img/zngy_p2.a2fda67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/zngy_p2.png
// module id = 1JGN
// module chunks = 19